import { render } from "./SingleSelector.vue?vue&type=template&id=1f61445a"
import script from "./SingleSelector.vue?vue&type=script&lang=js"
export * from "./SingleSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__